import TkcWebSameOriginService from '../services/TkcWebSameOriginService';
import membershipStore from '../stores/membershipStore';
import { T } from '../stores/textStore';


function initProcessing(message='') {
    membershipStore.processing.set(true);
    membershipStore.processingMessage.set(message);   
}

function clearProcessing() {
    membershipStore.processing.set(false);
    membershipStore.processingMessage.set('');
}

function invalidateData() {
    //membershipStore.userSubscriptionsResultSet.set(null);
    membershipStore.reloadData.set(true);
}

export function syncUserSubscriptions() {    
    initProcessing(T('Loading your membership plan'));
    return (
        TkcWebSameOriginService.syncUserSubscriptionsWithNetsuite()
        .then(json => {
            clearProcessing();
            return json;
        })
    );
}

export function syncUserSubscriptionsMock() {
    return Promise.resolve({
        "stored_cc": {
            ccdefault: "T",
            ccexpiredate: "4/2026",
            ccname: "asdf",
            ccnumber: "************1111",
            paymentmethod: "VISA",
        },
        "eligible_for_trial": false,
        "default_currency": {
            "name": "US Dollar",
            "code": "USD",
            "symbol": "$",
            "netsuite_id": "1"
        },
        "territory_currency": {
            "name": "US Dollar",
            "code": "USD",
            "symbol": "$",
            "netsuite_id": "1"
        },
        "defacto_currency": {
            "name": "US Dollar",
            "code": "USD",
            "symbol": "$",
            "netsuite_id": "1"
        },        
        "_defacto_currency": {
            "name": "British Pounds",
            "code": "GBP",
            "symbol": "p-",
            "netsuite_id": "2"
        }      
    });
}

export function loadUserSubscriptions() {
    if (membershipStore.userSubscriptionsResultSet.get()) {
        return;
    }
    initProcessing(T('Loading your membership plan'));
    return (
        TkcWebSameOriginService.fetchUserSubscriptions()
        .then(json => {
            membershipStore.userSubscriptionsResultSet.set(json);
            clearProcessing();
        })
    );
}

export function loadMemberships() {
    if (membershipStore.membershipsResultSet.get()) {
        return;
    }
    initProcessing();
    return (
        TkcWebSameOriginService.fetchMemberships()
        .then(json => {
            membershipStore.membershipsResultSet.set(json);
            clearProcessing();
        })
    );
}

/*export function loadAllData() {		
    syncUserSubscriptions()
    .then(json => {
        //membershipStore.balance = json.balance;
        //membershipStore.storedCc = json.stored_cc; 
         membershipStore.storedCc = {
            "ccnumber": "************1881",
            "ccexpiredate": "1/2020",
            "ccname": "Holdy Holderson",
            "ccdefault": "T",
            "paymentmethod": "VISA"
        };
        loadMemberships()
        .then(() => {
            loadUserSubscriptions()
            .then(() => {
                const current = membershipStore.getCurrentUserSubscription();
                if (current.subscription.payment_frequency) {						
                    membershipStore.changeForm.set('payment_frequency', 
                            current.subscription.payment_frequency || 'annual');	
                }				
            })		
        })
    })
}*/

export function cancelUserSubscription(id) {
    initProcessing('Cancelling your membership plan');
    return (
        TkcWebSameOriginService.cancelUserSubscription(id)
        .then(json => {
            if (json.status !== 'ok') {
                membershipStore.alerts.push({ 
                    type:'error', 
                    message: T('Sorry! We encountered an error while cancelling your membership.') + ' ' + T('Please email care@kabbalah.com or call +1-888-898-8358 for assistance.'),
                });	                 
            } else {
                membershipStore.alerts.push({ 
                    type:'success', 
                    message: T('Your membership was successfully cancelled.'),
                });	                 
            }
            invalidateData();
            clearProcessing();
        })     
    );
}

export function processChangeForm() {     
    const payload = {}   
    const ccFields = [
        'cc_number', 'cc_holder_name', 'cc_expiration_month', 'cc_expiration_year', 'payment_method'
    ]
    const useStoredCc = membershipStore.changeForm.get('use_stored_cc');
    for (let key of membershipStore.changeForm.keys()) {
        if (useStoredCc && ccFields.includes(key)) {
            continue;
        }
        payload[key] = membershipStore.changeForm.get(key);
    }   
    /*if (membershipStore.isTrialMode()) {
        payload['trial'] = 'T';
    }*/
    if (membershipStore.multiCurrencyMode) {
        payload['netsuite_currency'] = membershipStore.defactoCurrency.netsuite_id;
    }
    const promotion = membershipStore.getPromotion();
    if (promotion) {
        payload['promotion'] = promotion.id;
    }
    initProcessing(); 
    return (
        TkcWebSameOriginService.changeUserSubscriptions(payload)
        .then(json => {                    
            if (json.status === 'ok' && typeof(window.gtag) === 'function') {                
                window.gtag('event', 'conversion', {'send_to': 'AW-1037159247/fbzkCPDyktgBEM-Wx-4D'});   
                const cashsale = json.data.initialPayment;
                const subscription = json.data.subscription;                
                let promoCode = '';
                const promotion = membershipStore.getPromotion();
                if (promotion) {
                    promoCode = promotion.code;
                } else if (membershipStore.isTrialMode()) {
                    //promoCode = '<trial>';
                }
                let analyticsPurchasePayload = {             
                    "transaction_id": cashsale ? cashsale.tranid : 'sub-' + subscription.subscriptionid,
                    //"affiliation": "Google online store",
                    "value": cashsale ? cashsale.total.replace(',', '') : 0,
                    "currency": cashsale ? cashsale.currencycode : subscription.currencycode,
                    "tax": 0,
                    "shipping": 0,
                    "items": [
                      {
                        "id": subscription.sku,
                        "name": subscription.sku,
                        //"list_name": "Search Results",
                        //"brand": "Google",
                        "category": "Membership",
                        //"variant": "Black",
                        //"list_position": 1,
                        "quantity": 1,
                        "price": cashsale ? cashsale.total.replace(',', '') : 0,
                      },
                    ],
                    'coupon': promoCode,
                }     
                //console.log('GGGGGGGGG', analyticsPurchasePayload);   
                window.gtag('event', 'purchase', analyticsPurchasePayload);
            }  
            if (json.status === 'ok' && typeof window.fbq === "function") {   
                const promotion = membershipStore.getPromotion();
                let promoCode = '';
                if (promotion) {
                    promoCode = promotion.code;
                }                               
                window.fbq('track', 'CompleteRegistration', { promotion: promoCode });
            }        
            invalidateData();
            clearProcessing();
            if (json.status !== 'ok') {
                membershipStore.alerts.push({ 
                    type:'error', 
                    message: T('Sorry! We encountered an error while trying to process your payment. Click below to try again. If you’ve tried more than once, please email care@kabbalah.com or call +1-888-898-8358.'),
                });	                
                membershipStore.changeFormProcessError.set(true);            
            } else {            
                membershipStore.changeFormProcessSuccess.set(true);
            }
        })
    );
}

export function processCreditCardChangeForm() {     
    const payload = {}   
    for (let key of membershipStore.creditCardChangeForm.keys()) {
        payload[key] = membershipStore.creditCardChangeForm.get(key);
    }   
    initProcessing();
    return (
        TkcWebSameOriginService.changeCreditCard(payload)
        .then(json => {              
            if (json.status !== 'ok') {
                membershipStore.alerts.push({ 
                    type:'error', 
                    message: T('Sorry! We encountered an error while trying to change your credit card. Please email care@kabbalah.com or call +1-888-898-8358 for assistance.'),
                });	                
            } else {
                membershipStore.alerts.push({ 
                    type:'success', 
                    message: T('Your new card has been succesfully added.'),
                });	                  
                membershipStore.creditCardChangeFormProcessSuccess.set(true);     
                membershipStore.creditCardChangeForm.replace({});               
            }                 
            invalidateData();
            clearProcessing();
        })
    );
}

export function loadPromotion() {    
    membershipStore.promotionsResultSet.set(null);
    membershipStore.prmotionAppliedSuccessfully.set(false);
    membershipStore.promotionErrorMessage.set(null);
    const promoCode = membershipStore.promoCode.get();
    if (!promoCode) {
        return;
    }
    const membershipSlug = membershipStore.changeForm.get('membership');
    const paymentFrequency = membershipStore.changeForm.get('payment_frequency');
    const netsuiteCurrencyId = membershipStore.defactoCurrency.netsuite_id;
    initProcessing();
    return (
        TkcWebSameOriginService.fetchPromotions(promoCode, membershipSlug, paymentFrequency, netsuiteCurrencyId)
        .then(json => {
            if (!json.count) {                
                membershipStore.promotionErrorMessage.set(T('You have entered an invalid promo code.'));                
            } else {            
                if (membershipStore.changeForm.get('payment_frequency') !== 'monthly') {                    
                    membershipStore.promotionErrorMessage.set(T('This promotion is only valid for monthly plans. To use this promo code, please change the plan type to "Monthly".'));
                } else {       
                    membershipStore.promotionsResultSet.set(json);   
                    membershipStore.prmotionAppliedSuccessfully.set(true);         
                }
            }
            clearProcessing();
        })
    );
}


// WEBPACK FOOTER //
// ./src/actions/membershipActions.js